import React from "react";
import CIcon from "@coreui/icons-react";
import {
  cilClipboard,
  cilCommentBubble,
  cilFax,
  cilFeaturedPlaylist,
  cilIndustry,
  cilRowing,
  cilSpeedometer,
  cilUser,
  cilVideo,
  cilEnvelopeClosed,
  cilStar,
} from "@coreui/icons";
import { cilAddressBook, cilCast } from "@coreui/icons";

import { CNavItem } from "@coreui/react";
import ROUTE_NAMES from "../routes/routeNames";

/**
 * @description NAVLINKS CONTENTS FOR SIDEBAR
 */

const navLinks = [
  {
    component: CNavItem,
    name: "Dashboard",
    to: "/dashboard",
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Users",
    to: "/users",
    icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Content Management",
    to: "/content-management",
    icon: <CIcon icon={cilFax} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Sites",
    to: "/sites",
    icon: <CIcon icon={cilRowing} customClassName={"nav-icon"} />,
  },
  {
    component: CNavItem,
    name: "Cities",
    to: "/cities",
    icon: <CIcon icon={cilIndustry} customClassName={"nav-icon"} />,
  },
  {
    component: CNavItem,
    name: "Report Management",
    to: "/report-management",
    icon: <CIcon icon={cilClipboard} customClassName={"nav-icon"} />,
  },
  {
    component: CNavItem,
    name: "Feedback",
    to: ROUTE_NAMES.MAIN_ROUTES.FEEDBACK,
    icon: <CIcon icon={cilFeaturedPlaylist} customClassName={"nav-icon"} />,
  },
  {
    component: CNavItem,
    name: "Queries",
    to: ROUTE_NAMES.MAIN_ROUTES.QUERIES,
    icon: <CIcon icon={cilCommentBubble} customClassName={"nav-icon"} />,
  },
  {
    component: CNavItem,
    name: "Emails",
    to: ROUTE_NAMES.MAIN_ROUTES.EMAILS,
    icon: <CIcon icon={cilEnvelopeClosed} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "How-To Videos",
    to: ROUTE_NAMES.MAIN_ROUTES.HOT_TO_VIDEOS,
    icon: <CIcon icon={cilVideo} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Articles",
    to: ROUTE_NAMES.MAIN_ROUTES.ARTICLES,
    icon: <CIcon icon={cilCast} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Ratings and Reviews",
    to: ROUTE_NAMES.MAIN_ROUTES.RATINGS_AND_REVIEWS,
    icon: <CIcon icon={cilStar} customClassName={"nav-icon"} />,
  },
];
export default navLinks;

export const modes = [
  { id: 1, value: "User", icon: cilAddressBook },
  { id: 2, value: "Post", icon: cilCast },
];
